<template>
  <footer>
    <div class="chat-trigger">
      <Button @click="isChatOpen = true" type="primary" style="width: 44px">
        <Message />
      </Button>
      <component
        isMobile
        :is="chat.component"
        :is-open="isChatOpen"
        @close="isChatOpen = false"
      />
    </div>
    <GradientList />
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import GradientList from "@/components/icons/GradientList.vue"
import Button from "@/components/uikit/Button.vue"
import { Message } from "@/components/icons"
import Chat from "@/components/chat/mobile/index.vue"
import AdminChat from "../chat/desktop/Admin/AdminChat.vue"
import ModeratorChat from "../chat/desktop/Moderator/ModeratorChat.vue"

export default defineComponent({
  name: "MobileFooterComponent",
  components: { GradientList, Button, Message, Chat, AdminChat, ModeratorChat },
  data() {
    return {
      isChatOpen: false,
    }
  },
  computed: {
    chat() {
      if (this.$route.path.startsWith("/admin")) {
        return {
          component: AdminChat,
          opened: false,
        }
      }

      if (this.$route.path.startsWith("/moderator")) {
        return {
          component: ModeratorChat,
          opened: false,
        }
      }

      return {
        component: Chat,
        opened: false,
      }
    },
  },
})
</script>
<style lang="scss" scoped>
footer {
  position: relative;
  .chat-trigger {
    z-index: 2;
    position: fixed;
    right: 8px;
    bottom: 91px;
    display: none;
  }
}
</style>
